import { Routes, Route } from "react-router-dom";

import AdminLayout from "../pages/superAdmin/AdminLayout";
import AdminDashboardPage from "../pages/superAdmin/AdminDashboardPage";
import CompaniesPage from "@/pages/superAdmin/CompaniesPage";
import UsersPage from "@/pages/superAdmin/UsersPage";
import RolesPage from "@/pages/superAdmin/RolesPage";
import CompanyDetailsModal from "@/pages/superAdmin/modals/CompanyDetailsModal";
import BaseModulesPage from "@/pages/superAdmin/pages/BaseModulePage";
import ModulesPage from "@/pages/superAdmin/pages/ModulesPage";
import SubModulesPage from "@/pages/superAdmin/pages/SubModulesPage";
import RolePermissionsPage from "@/pages/superAdmin/pages/RolePermissionsPage";
import BaseNavigationPage from "@/pages/superAdmin/pages/BaseNavigationPage";
import NavigationPage from "@/pages/superAdmin/pages/NavigationPage";
import NavVisibilityPage from "@/pages/superAdmin/pages/NavVisibilityPage";
import SubNavigationPage from "@/pages/superAdmin/pages/SubNavigationPage";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminLayout />}>
        <Route index element={<AdminDashboardPage />} replace />
        <Route path="companies" element={<CompaniesPage />} />
        <Route path="companies/:companyId" element={<CompanyDetailsModal />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="base_modules" element={<BaseModulesPage />} />
        <Route
          path="base_modules/:baseModuleId/modules/"
          element={<ModulesPage />}
        />
        <Route
          path="base_modules/:baseModuleId/modules/:moduleId/sub_modules"
          element={<SubModulesPage />}
        />
        <Route path="roles" element={<RolesPage />} />
        <Route
          path="roles/:roleId/permissions"
          element={<RolePermissionsPage />}
        />
        <Route path="base_navigations" element={<BaseNavigationPage />} />
        <Route
          path="base_navigations/:baseNavigationId/navigations"
          element={<NavigationPage />}
        />
        <Route
          path="base_navigations/:baseNavigationId/navigations/:navigationId/sub_navigations"
          element={<SubNavigationPage />}
        />
        <Route path="nav_visibility" element={<NavVisibilityPage />} />
      </Route>
    </Routes>
  );
};

export default AdminRoutes;
